import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20artistic%20composition%20with%20deep%20red%20and%20crimson%20tones%2C%20abstract%20geometric%20shapes%20overlapping%2C%20mysterious%20silhouettes%2C%20newsroom%20atmosphere%2C%20journalistic%20and%20investigative%20mood%2C%20dark%20elegant%20background%20with%20warm%20amber%20accents%2C%20texture%20of%20newspaper%20print%20subtle%20overlay%2C%20cinematic%20wide%20composition&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="黑料中文网 - 娱乐爆料平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto text-center px-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-6 backdrop-blur-sm">
            <i className="ri-fire-line"></i>
            <span>每日更新独家爆料</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
            娱乐圈<span className="text-primary-400">黑料</span>，一站掌握
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            黑料中文网汇聚最新最热的明星爆料、网红内幕、综艺真相，深度揭秘娱乐圈不为人知的真相，让你第一时间掌握圈内动态。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/star-scandal"
              className="px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              查看最新爆料
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full border border-white/30 hover:border-white/60 text-white font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              了解我们
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">12,580+</div>
              <div className="text-xs text-white/60 mt-1">独家爆料</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">6大</div>
              <div className="text-xs text-white/60 mt-1">内容分类</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">860万+</div>
              <div className="text-xs text-white/60 mt-1">月活跃读者</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}